import React from 'react';

// Text wordmark in the editorial display face (Fraunces italic).
// "poet" in ink, "tik" in the raspberry-pink accent.
const Logo = ({ size = 'md' }) => {
  const sizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
  };

  return (
    <span
      className={`font-display italic font-semibold lowercase tracking-tight leading-none select-none ${sizes[size]}`}
      data-testid="poettik-logo"
    >
      <span className="text-foreground">poet</span>
      <span className="text-primary">tik</span>
    </span>
  );
};

export default Logo;
